import React from 'react';
import { get, map, size, forEach, join, chunk, times } from 'lodash';
import { object } from 'prop-types';
import { OrderPdfWrapper } from '../../src/components/pdf-commons';
import { cleanOrderId, baggingEnums, getPickingQuantityByUni } from '../../src/utils/misc';
import { Row, Column, Text, FlexContainer } from '../../src/components/common';
import moment from 'moment';
import QRCode from 'qrcode.react';

const OrderLabels = ({ match }) => {
    const orderId = get(match, 'params.id', null);

    const getLooseProducts = (data) => {
        const items = get(data, 'assignInfo.items', {});
        let parentProducts = [];

        forEach(items, ({ substitution, unpackaged, ...item }) => {
            if (unpackaged) {
                times(getPickingQuantityByUni(item), () => {
                    parentProducts.push(item);
                });
            };
            if (size(substitution) > 0) {
                forEach(substitution, substitute => {
                    if (get(substitute, 'unpackaged')) {
                        times(getPickingQuantityByUni(substitute), () => {
                            parentProducts.push(substitute);
                        });
                    }
                });
            }
        });

        return parentProducts;
    };

    const boxesAndBags = (baggingDetail) => {
        let sortedByType = [];
        forEach(baggingDetail, ({ randomId, id, ...elements }) => {
            sortedByType = [...sortedByType, { ...elements, value: [`${randomId ? '-' : id}`] }];
        });
        return map(sortedByType, ({ type, value, ...elements }) => {
            return {
                ...elements,
                type,
                name: baggingEnums[type],
                ean: join(value, ' - ')
            };
        });
    };

    const borderBottomStyle = params => ({ borderBottom: `${get(params, 'size', 1)}px solid ${get(params, 'color', '#333333')}` });

    return (
        <OrderPdfWrapper orderId={orderId} withoutFooter insideOrderLabel >
            {
                ({ data }) => {
                    const looseProducts = getLooseProducts(data);
                    const baggingDetail = get(data, 'assignInfo.baggingInfo.detail', {});
                    const bags = boxesAndBags(baggingDetail);
                    const groupedItems = chunk([...bags, ...looseProducts], 2);
                    const shippingETA = moment(get(data, 'logisticsInfo.shippingETA', ''), 'YYYY-MM-DD HH:mm:ss').format('HH:mm');
                    const shippingETAend = moment(get(data, 'logisticsInfo.shippingETAend', ''), 'YYYY-MM-DD HH:mm:ss').format('HH:mm');
                    const shippingETADate = moment(get(data, 'logisticsInfo.shippingETA', ''), 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY');
                    const courierId = get(data, 'logisticsInfo.deliveryIds[0].courierId', '');
                    const fullName = `${get(data, 'customer.firstName', '')} ${get(data, 'customer.lastName', '')}`;
                    const neighborhood = get(data, 'selectedAddress.neighborhood', '');
                    const truncateText = (text, sizeToTruncate) => size(text) > sizeToTruncate ? `${text.substring(0, sizeToTruncate - 1)}...` : text;
                    return (
                        <>
                            <FlexContainer direction='column' style={{ margin: 'auto' }}>
                                { map(groupedItems, (pairItems, pairIndex) => (
                                    <div key={pairIndex} style={{ height: '376.96px', margin: 'auto', width: '10cm' }}>
                                        <Row style={{ width: size(pairItems) < 2 ? '5cm' : '10cm' }} >
                                            { map(pairItems, ({ name, ean, ...item }, index) => {
                                                const hasCorrelative = get(item, 'correlative', false);
                                                const itemName = `${ean === '-' || !hasCorrelative ? name : `${ean} - ${name}`}`;
                                                const qrValue = () => {
                                                    const sequence = get(data, 'sequence', '1');
                                                    if (hasCorrelative) return `${sequence}${get(item, 'type', 1)}${hasCorrelative}`;
                                                    return `${sequence}${ean}`;
                                                };
                                                return (
                                                    <Column key={index} borderRadius={4} margin={8} style={{ border: '1px solid #000000' }} fixedHeight={360} mR={index === 0 ? 5 : 0} >
                                                        <Row style={{ display: 'block', margin: '4px' }}>
                                                            <Row style={borderBottomStyle({ size: 4 })} height={50} justify='center'>
                                                                <Text size={14} text={'PEDIDO:'} />
                                                                <Text text={cleanOrderId(orderId)} size={20} strong />
                                                            </Row>
                                                            <Row style={borderBottomStyle()} height={115} justify='center'>
                                                                <Text size={14} text={'VENTANA HORARIA'} />
                                                                <Text text={`${shippingETA} a ${shippingETAend}`} size={20} strong />
                                                                <Text text={shippingETADate} />
                                                                <Text text={`${neighborhood} - ${courierId}`} strong size={15} align='center' />
                                                            </Row>
                                                            <Row style={borderBottomStyle()} height={120} align='center' justify='center'>
                                                                <QRCode value={qrValue()} size={110} />
                                                            </Row>
                                                            <Row style={borderBottomStyle()} height={40} align='center' justify='center'>
                                                                <Text text={truncateText(itemName, 40)} align='center' />
                                                            </Row>
                                                            <Row height={30} justify='center'>
                                                                <Text text={truncateText(fullName, 15)} size={15} strong />
                                                            </Row>
                                                        </Row>
                                                    </Column>
                                                );
                                            })}
                                        </Row>
                                    </div>
                                ))}
                            </FlexContainer>
                        </>
                    );
                }
            }
        </OrderPdfWrapper>
    );
};

OrderLabels.propTypes = {
    match: object
};

export default OrderLabels;
